import BaseModelLoader from "./BaseModelLoader";

class GenericModelLoader extends BaseModelLoader {

}

export default GenericModelLoader
